import { AllocationItem } from "./allocationitem";

export class AllocationDefinition {
    Id : number;
    CompanyId : number;
    AllocationItemId : number;
    AllocationItem: AllocationItem;
    AllocationItemName: string;
    SourceDimensionId: number;
    SourceDimension: string;
    SourceDimensionValueId : number;
    SourceDimensionValue: string;
    TargetDimensionId : number;
    TargetDimension: string;
    Description: string;
    OverrideDirectPosting: string
    ProcessingOrder:number;
}
